module.exports = "<a \n    *ngFor=\"let site of sites; trackBy: index\" \n    title=\"{{site.domain}}\" \n    href=\"{{site?.permalink}}\" \n    target=\"_blank\" \n    class=\"site-{{site.abbreviation}}\" \n    [ngClass]=\"{primary: site.primary}\">\n        {{site.abbreviation}}\n</a>"


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/sites.component.html
// module id = ../../../../../src/swarm/src/app/fields/sites.component.html
// module chunks = main